const categorySc = [
  "法律服務",
  "會計及稅務",
  "知識產權",
  "金融服務",
  "跨境貿易爭端護航計劃 (1 小時免費法律諮詢)",
  '檢測及認證',
  '市場推廣服務',
  // "金融",
  // "商業服務",
  // "銀行",
  // "保險",
  // "影視行業",
];

export default categorySc;
